import { ApolloError, FetchResult, useMutation } from '@apollo/client';
import { useCallback, useMemo } from 'react';
import { Mutations } from '@shared/api';

interface UpdateWorkflowEntity {
  updateWorkflowEntity: (
    id: string,
    fields: MBAPI.Scalar.JSON,
  ) => Promise<FetchResult<MBAPI.UpdateWorkflowEntityMutation>>;
  loading: boolean;
  error: ApolloError | undefined;
}

export function useUpdateWorkflowEntity(): UpdateWorkflowEntity {
  const [update, { loading, error }] = useMutation<
    MBAPI.UpdateWorkflowEntityMutation,
    MBAPI.UpdateWorkflowEntityMutationVariables
  >(Mutations.entity.updateWorkflowEntity);

  const updateWorkflowEntity = useCallback(
    (id: string, fields: MBAPI.Scalar.JSON) => {
      return update({
        variables: {
          input: {
            id,
            fields,
          },
        },
      });
    },
    [update],
  );

  return useMemo(() => {
    return {
      updateWorkflowEntity,
      loading,
      error,
    };
  }, [updateWorkflowEntity, loading, error]);
}
